import { useFlag } from '@calendly/feature-check-react';
import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { useInterval } from '@calendly/ui/hooks/use-interval';
import { useRef, useState, useEffect } from 'react';
import { getToolCallMessage } from '../utils';
import { useToolCallCycling } from './useToolCallCycling';
import { IconGradientStar } from '../assets/icon-gradient-star';
const thinkingMessages = ['publisher.agent_hub.thinking', 'publisher.agent_hub.analyzing', 'publisher.agent_hub.processing', 'publisher.agent_hub.gathering_info', 'publisher.agent_hub.almost_ready'];
const loaderContainerCss = "l1wb1a3j";
const spinningRingCss = "s10u8o7e";
export const ThinkingLoader = ({
  toolCalls = []
}) => {
  const isShowToolCallsFeatureEnabled = useFlag('caf_show_thinking_steps_feature');
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const lastMappedMessageRef = useRef(null);
  const messagesLength = thinkingMessages.length;

  // Use custom hook to handle tool call cycling logic
  const {
    displayedToolCall
  } = useToolCallCycling(toolCalls, isShowToolCallsFeatureEnabled);

  // Clear lastMappedMessageRef when toolCalls becomes empty to prevent showing old messages
  useEffect(() => {
    if (toolCalls.length === 0) {
      lastMappedMessageRef.current = null;
    }
  }, [toolCalls.length]);
  useInterval(() => {
    setCurrentMessageIndex(i => (i + 1) % messagesLength);
  }, !isShowToolCallsFeatureEnabled && messagesLength > 1 ? 3000 : null // null pauses interval so we don't need to iterate
  );

  // Get the display message based on feature flag and tool call
  const getDisplayMessage = () => {
    if (isShowToolCallsFeatureEnabled && displayedToolCall) {
      const toolCallName = displayedToolCall.name;
      const mappedMessage = getToolCallMessage(toolCallName);

      // If tool call has a mapping, store it and return it
      if (mappedMessage) {
        lastMappedMessageRef.current = mappedMessage;
        return mappedMessage;
      }

      // If no mapping, use the last successfully mapped message
      if (lastMappedMessageRef.current) {
        return lastMappedMessageRef.current;
      }

      // Fallback to "thinking" only if there's no previous mapped message
      return I18n.t('publisher.agent_hub.thinking');
    }
    return I18n.t(thinkingMessages[currentMessageIndex]);
  };
  return <div className={loaderContainerCss}>
      <div className={spinningRingCss}>
        <IconGradientStar />
      </div>
      <BodyText weight="semibold">
        {getDisplayMessage()}
        ...
      </BodyText>
    </div>;
};

require("./ThinkingLoader.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ThinkingLoader.js");